// The sonar plot of the contacts: the one book that the sonar designations
// (card 41) and the listening watch (card 47) read (R2626, R2657,
// ui-map-interface.md §17.3.41).
//
// The sonar room names every contact in the order it is heard: S1, S2,
// ... A contact keeps its number while the picture holds it. A contact
// that drops and comes back is a new number, because the client cannot
// know it is the same hull. A new world starts the book again.
//
// The book walks the hulls of a frame once, whichever piece asks first in
// that frame.

import type { ChartFleet } from '../context';

export class ContactBook {
  private readonly nums = new Map<number, number>();
  private next = 1;
  private stamp = -1;
  /** The ids a walk saw, reused between walks (§10). */
  private readonly seen = new Set<number>();

  /** A new world: every number goes. */
  reset(): void {
    this.nums.clear();
    this.next = 1;
    this.stamp = -1;
  }

  /** The designation of a held contact, or 0. */
  numberOf(fleetId: number): number {
    return this.nums.get(fleetId) ?? 0;
  }

  /**
   * Walks the hulls of one frame, once a frame: a new contact takes the next
   * number, and a contact the frame no longer holds loses its number. A hull
   * of the viewer's faction is no contact.
   */
  observe(fleets: readonly ChartFleet[], faction: number, stamp: number): void {
    if (stamp === this.stamp) return;
    this.stamp = stamp;
    const seen = this.seen;
    seen.clear();
    for (const f of fleets) {
      if (f.own || f.faction === faction) continue;
      seen.add(f.id);
      if (!this.nums.has(f.id)) this.nums.set(f.id, this.next++);
    }
    for (const id of this.nums.keys()) {
      if (!seen.has(id)) this.nums.delete(id);
    }
  }
}

/** The one book the pieces read. */
export const contactBook = new ContactBook();
